module.exports = __webpack_public_path__ + "img/qszm.b05813cf.jpg";